/**
 * Form panel, that allows inheritance of forms. Items are defined separately from layout.
 */
mx.comp.XtensibleFormPanel = Ext.extend(mx.comp.FormPanel, {
    layout: 'anchor',
    border: false,
    header: false,
    autoHeight: true,
    readOnly: false,
    buildFormOnInit: true, // set to false to prevent form elements to appear on panel (in this case you should call .buildForm() method manually for form to appear on screen
    /**
     * Contains all named elements of form
     * @var object
     */
    els: {},
    customButtons: {},
    updateForm: Ext.emptyFn,
    columnsWidths: function() {
        return null;
    },
    buildElements: function() {
        return {};
    },
    buildButtons: function() {
        return {};
    },
    buildColumns: function() {
        return null;
    },
    buildFieldSets: function() {
        return null;
    },
    buildLayout: function() {
        return null;
    },
    beforeBuild: function() {
        // override this method to hook into init component, when all elements are initialized,
        // but not already added to form
    },
    afterBuild: function() {
        // override this method to hook into init component, when all elements are added to form
    },
    getFormValues: function() {
        var values = {};
        for (var i in this.els) {
            if (this.els[i].getName && this.els[i].getValue()) {
                var value = this.els[i].getValue();
                if (this.els[i].getValue().getRecordId) {
                    value = this.els[i].getValue().getRecordId();
                } else if (Ext.isArray(this.els[i].getValue()) && this.els[i].getValue().length == 0) {
                    value = null;
                } else if (this.els[i].getValue() === true) {
                    value = this.els[i].getValue();
                } else if (this.els[i].getValue() instanceof Date) {
                    value = mx.Util.getClientDate(this.els[i].getValue().getTime()).getTime();
                }
                values[this.els[i].getName()] = value;
            }
        }
        return values;
    },
    getAllValues: function() {
        var values = {};
        for (var i in this.els) {
            if (this.els[i].getName && this.els[i].getValue()) {
                var value = this.els[i].getValue();
                values[this.els[i].getName()] = value;
            }
        }
        return values;
    },
    // hook to transform form, based on data, when record is loaded into form
    onRecordLoaded: function(record) {
        for (var i in this.els) {
            if (this.els[i].onRecordLoaded) {
                this.els[i].onRecordLoaded.call(this.els[i], record, this);
            }
        }
        this.updateRequiredField(record);
        for (var i in this.customButtons) {
            if (this.customButtons[i].onRecordLoaded) {
                this.customButtons[i].onRecordLoaded.call(this.customButtons[i], record, this);
            }
        }

        this.fireEvent('onRecordLoaded', this, record);

        if (this.readOnly) {
            this.getForm().items.each(this.disaleFormElements);
        }

        if (record.data.attributeValues) {
            var f;
            for (var i in record.data.attributeValues) {
                this.getForm().items.each(function(field) {
                    if (field.isMetadataDriven && field.isMetadataDriven() && field.getAttributeName) {
                        if (field.getAttributeName() == i) {
                            var value = field.convertValueFromServer(record.data.attributeValues[i]);
                            field.originalValue = value;
                            field.setValue(value);
                            if (field.onRecordLoaded) {
                                field.onRecordLoaded.call(field, record, this);
                            }
                        }
                    }
                }, this);
            }
        }
    },
    updateRequiredField: function(record) {
        for (var i in this.els) {
            if (this.els[i].updateRequiredField) {
                this.els[i].updateRequiredField.call(this.els[i], record, this);
            }
        }
    },
    // pre-ready elements to use in forms:
    preReady: {
        emptyString: function(height) {
            height = height || 26;
            return new Ext.Panel({
                border: false,
                style: 'height: ' + height + 'px',
            });
        },
        idField: function() {
            return new Ext.form.Hidden({
                name: 'id',
            });
        },
        geoCombobox: function(params) {
            params = params || {};
            return new mx.comp.GeoComboBox(
                Ext.apply(
                    {
                        displayField: 'name',
                        mode: 'local',
                        anchor: '100%',
                        triggerAction: 'all',
                        showMapIcon: false,
                        geocodingTypes: ['landmarks'],
                        getArguments: function() {
                            return {
                                region: new mx.data.Region({
                                    id: MXBT.get('defaultMapId'),
                                    title: MXBT.get('defaultMapTitle'),
                                }),
                            };
                        },
                        maxLength: mx.DEFAULT_MAX_LENGTH,
                        allowBlank: false,
                    },
                    params
                )
            );
        }, //
        dateTime: function(params, dateFormat, timeFormat) {
            dateFormat = dateFormat || 'fulldate';
            timeFormat = timeFormat || 'time';

            return new Ext.ux.form.DateTime(
                Ext.apply(
                    {
                        timeFormat: MXBT.getDateFormat(timeFormat),
                        timeConfig: {
                            emptyText: MXBT.getDateFormat(timeFormat, 'hint'),
                            altFormats: MXBT.getDateFormat(timeFormat, 'alt'),
                            allowBlank: true,
                        },
                        dateFormat: MXBT.getDateFormat(dateFormat),
                        dateConfig: {
                            emptyText: MXBT.getDateFormat(dateFormat, 'hint'),
                            altFormats: MXBT.getDateFormat(dateFormat, 'alt'),
                            allowBlank: false,
                        },
                    },
                    params
                )
            );
        },
        columnsInFieldset: function(title, columns, fieldSetConfig, hidden) {
            var fieldSet = new Ext.form.FieldSet({
                title: title,
                layout: 'column',
                autoHeight: true,
                hideBorders: true,
                collapsible: false,
                hidden: !!hidden,
            });
            var columnWidth = 1 / columns.length;
            for (var i = 0; i < columns.length; i++) {
                if (columns[i].length) {
                    fieldSet.add(
                        Ext.apply(
                            {
                                columnWidth: columnWidth,
                                border: false,
                                header: false,
                                layout: 'mx-form',
                                defaults: {anchor: '-5'},
                                items: columns[i],
                            },
                            fieldSetConfig || {}
                        )
                    );
                }
            }
            return fieldSet;
        },
        columnsPanel: function(columns, config) {
            var panel = new Ext.Panel({
                layout: 'column',
                autoHeight: true,
                border: false,
            });
            var columnWidth = 1 / columns.length;
            for (var i = 0; i < columns.length; i++) {
                if (columns[i].length) {
                    panel.add(
                        Ext.apply(
                            {
                                columnWidth: columnWidth,
                                border: false,
                                header: false,
                                layout: 'mx-form',
                                defaults: {anchor: '-5'},
                                items: columns[i],
                            },
                            config || {}
                        )
                    );
                }
            }
            return panel;
        },
    },
    initComponent: function() {
        mx.comp.XtensibleFormPanel.superclass.initComponent.apply(this, arguments);
        this.addEvents('onRecordLoaded', 'beforesubmit', 'beforeSubmitAfterValidation');

        this.els = this.buildElements();

        if (this.buildFormOnInit) {
            this.buildForm(true);
        }
    },
    buildForm: function(initial) {
        this.beforeBuild.call(this);

        for (var i in this.els) {
            if (this.els[i].initialConfig && this.els[i].initialConfig.listeners) {
                this.els[i].scope = this;
            }
        }

        var columns, fieldsets, items;
        if ((columns = this.buildColumns())) {
            // shortcut for 'columns' layout
            var didLayoutOnce = false;
            var wrapPanel = new Ext.Panel({
                layout: 'column',
                border: false,
                listeners: {
                    afterlayout: function() {
                        if (!didLayoutOnce) {
                            didLayoutOnce = true;
                            this.ownerCt.ownerCt.doLayout();
                        }
                    },
                },
            });
            for (var i = 0; i < columns.length; i++) {
                var columnWidths = this.columnsWidths();
                var columnWidth;
                if (columnWidths) {
                    columnWidth = columnWidths[i];
                } else {
                    columnWidth = 1 / columns.length;
                }
                if (columns[i].length) {
                    wrapPanel.add({
                        columnWidth: columnWidth,
                        border: false,
                        header: false,
                        layout: 'mx-form',
                        defaults: {anchor: '-5'},
                        id: 'FormPanel-' + i,
                        items: columns[i],
                    });
                }
            }
            this.add(wrapPanel);
        } else if ((fieldsets = this.buildFieldSets())) {
            // shortcut for 'fieldsets' layout
            for (var i in fieldsets) {
                if (fieldsets[i].title && fieldsets[i].items && fieldsets[i].items.length) {
                    this.layout = 'anchor';
                    this.bodyStyle = 'padding: 5px;';
                    this.add(
                        new Ext.form.FieldSet({
                            //                                name: 'trackingfieldset_container',
                            title: fieldsets[i].title,
                            layout: 'mx-form',
                            autoHeight: true,
                            hideBorders: true,
                            collapsible: false,
                            labelWidth: 260,
                            defaults: {
                                anchor: '100%',
                            },
                            items: fieldsets[i].items,
                        })
                    );
                }
            }
        } else {
            // todo: create method for specifying any layout configuration
            this.buildLayout();
        }

        if (!initial) {
            this.doLayout();
        }

        this.customButtons = this.buildButtons();

        this.afterBuild.call(this);
    },
});
